<template>
  <div class="map">
    <section class="map__spec">
      <div>
        <h4 class="map__title" data-anim="title">Location</h4>
        <div>
          <p
            v-for="text in map.location"
            :key="text"
            v-html="text"
            data-anim="text"
          >
            {{ text }}
          </p>
        </div>
      </div>
      <div>
        <h4 class="map__title" data-anim="title">Gps</h4>
        <p data-anim="text">
          {{ map.gps.lat }}<br>
          {{ map.gps.lng }}
        </p>
      </div>
      <div>
        <h4 class="map__title" data-anim="title">Schedule</h4>
        <div>
          <p
            v-for="text in map.schedule"
            :key="text"
            v-html="text"
            data-anim="text"
          >
            {{ text }}
          </p>
        </div>
      </div>
    </section>

    <MapContainer :image="map.image"></MapContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MapContainer from '@/components/MapContainer';

export default {
  name: 'Map',

  components: {
    MapContainer,
  },

  data() {
    return {
      map: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),
  },

  created() {
    this.map = this.getDataCityComponent(this.$route.params.city, 'map');
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.map {
  &__title {
    font-size: 1rem;
  }

  &__spec {
    padding: 60px 40px 40px 40px;

    @include mq(sm) {
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      padding: 180px 140px 140px 120px;
    }

    > div {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 5%;
      padding-bottom: 20px;

      @include mq(sm) {
        display: block;
        padding-bottom: 0;
      }
    }
  }

  p {
    color: $color-gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue